import Breadcrumbs from '@v2/shared/components/Breadcrumbs';
import ContentCard from '@v2/shared/components/ContentCard';
import PageHeading from '@v2/shared/components/PageHeading';
import ContactForm from './ContactForm';
import type { ContactPageProps } from './types';

/** The legacy page's opening line, which sat under its H1 inside the same `<header>`. */
const INTRO =
  "Questions or comments regarding your order or anything else? Contact us below and we'll get back to you within a couple days.";

/**
 * /contact.
 *
 * The one institutional page here that is not just copy. The heading and the card are the
 * set's, and the form inside the card is the legacy one, field for field.
 */
export default function Contact({ subjects, customer, sent }: ContactPageProps) {
  return (
    <>
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Contact Us' }]} />

      <PageHeading eyebrow="Customer Information" intro={INTRO}>
        Contact Us
      </PageHeading>

      {/* No `prose` here, unlike the rest of the set. Nothing inside this card is running
          copy — it is a form, or the confirmation that replaces it — and the reading
          treatment restyles whatever it is given, including the confirmation's paragraph.
          The page's one piece of copy is the intro, which PageHeading sets above. */}
      <div className="mt-6 flex flex-col gap-6">
        <ContentCard>
          <ContactForm subjects={subjects} customer={customer} sent={sent} />
        </ContentCard>
      </div>
    </>
  );
}

Contact.layoutName = 'Layouts.Institutional';
